import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class WizardStepAPI extends ComponentAPI {
    /**
     * Gets the step identifier.
     *
     * @returns The step identifier.
     */
    getIdentifier() {
        return this.state.identifier;
    }
    /**
     * Gets the step subtitle.
     *
     * @returns The step subtitle.
     */
    getSubtitle() {
        return this.state.subtitle;
    }
    /**
     * Sets the step subtitle.
     *
     * @param subtitle - The step subtitle.
     */
    setSubtitle(subtitle) {
        this.setState({ subtitle });
    }
    /**
     * Gets if the wizard step is read only.
     *
     * @returns If the wizard step is read only.
     */
    isReadOnly() {
        return this.state.readOnly;
    }
    /**
     * Sets if the wizard step is read only.
     *
     * @param readOnly - If the wizard step is read only.
     */
    setReadOnly(readOnly) {
        return this.setState({ readOnly });
    }
    /**
     * Gets the step title.
     *
     * @returns The step title.
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets the step title.
     *
     * @param title - The step title.
     */
    setTitle(title) {
        this.setState({ title });
    }
}
export default WizardStepAPI;
//# sourceMappingURL=wizard-step-api.js.map